import { useEffect, useState } from "react";
import { AlertTriangle, Info, XCircle } from "lucide-react";
import api from "@/lib/api";

const STYLES = {
  danger: { bg: "#FEF2F2", border: "#FECACA", fg: "#B91C1C", Icon: XCircle },
  warning: { bg: "#FFFBEB", border: "#FDE68A", fg: "#B45309", Icon: AlertTriangle },
  info: { bg: "#EFF6FF", border: "#BFDBFE", fg: "#1D4ED8", Icon: Info },
};

export default function AlertsBanner({ onNavigate }) {
  const [alerts, setAlerts] = useState([]);
  useEffect(() => {
    api.get("/pilotage/alerts").then((r) => setAlerts(r.data.alerts || [])).catch(() => {});
  }, []);
  if (!alerts.length) return null;
  return (
    <div className="space-y-2 mb-4" data-testid="pilotage-alerts">
      {alerts.map((a, i) => {
        const s = STYLES[a.level] || STYLES.info;
        return (
          <button key={i} onClick={() => a.tab && onNavigate?.(a.tab)} data-testid={`pilotage-alert-${a.type}`}
            className="w-full flex items-center gap-2.5 rounded-xl border px-3.5 py-2.5 text-left transition-opacity hover:opacity-80"
            style={{ background: s.bg, borderColor: s.border }}>
            <s.Icon className="w-4 h-4 shrink-0" style={{ color: s.fg }} />
            <span className="text-xs font-semibold shrink-0" style={{ color: s.fg }}>{a.title}</span>
            <span className="text-xs text-neutral-500 truncate">{a.detail}</span>
          </button>
        );
      })}
    </div>
  );
}
